var map = {
	"./statusActionDoing.svg": 23471,
	"./statusActionLate.svg": 82517,
	"./statusAvalPending.svg": 270,
	"./statusCancel.svg": 20184,
	"./statusDoing.svg": 3313,
	"./statusDone.svg": 95227,
	"./statusOpen.svg": 78021,
	"./statusReasonDoing.svg": 79663,
	"./statusReasonLate.svg": 9697,
	"./statusRecusa.svg": 86507,
	"./statusTotal.svg": 90071
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37013;